export const NURIEMANGO_SET_USER = 'NURIEMANGO_SET_USER';
export const NURIEMANGO_RESET = 'NURIEMANGO_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
